import * as React from 'react';
import * as styles from './add-attribute-button.module.scss';
import { IconButton } from '@material-ui/core';
import { AddCircle } from '@material-ui/icons';
import { blue, colors } from '../../../theme/colors';
import clsx from 'clsx';

interface Props {
  label: string;
  handleClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
}

const AddAttribute = ({ label, handleClick, disabled }: Props) => {
  return (
    <div className={styles.addAttribute}>
      <IconButton size="small" onClick={handleClick} aria-label={label} disabled={disabled}>
        <AddCircle htmlColor={disabled ? colors.lightGrey : blue[600]} fontSize="small" />
      </IconButton>
      <p className={clsx(styles.label, disabled && styles.disabled)}>{label}</p>
    </div>
  );
};

export default AddAttribute;
